import clsx from "clsx"
import { useState } from "react"
import styled from "styled-components"

const Circle = styled.div`
  background-color: ${(props) => props.theme.palette.white};
  border-radius: 50%;
  height: 20px;
  transition: transform 0.3s;
  width: 20px;

  &.isActive {
    transform: translateX(24px);
  }
`
const SwitchContainer = styled.button`
  align-items: center;
  background-color: ${(props) => props.theme.palette.lightGray};
  border: none;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  height: 24px;
  padding: 2px;
  transition: background-color 0.3s;
  width: 48px;

  &.isActive {
    background-color: ${(props) => props.theme.palette.primary_one};
  }

  &.disabled {
    cursor: not-allowed;
  }
`

interface SwitchProps {
  initialState?: boolean
  value?: boolean
  disabled?: boolean
}

const Switch = (props: SwitchProps) => {
  const { initialState, value, disabled = false } = props
  const [isActive, setIsActive] = useState(initialState)

  const handleClick = () => {
    setIsActive(!isActive)
  }

  const active = typeof value !== "undefined" ? value : isActive

  return (
    <SwitchContainer
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className={clsx({ isActive: active, disabled })}
    >
      <Circle className={clsx({ isActive: active })} />
    </SwitchContainer>
  )
}

export default Switch
